var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDownloadBtn)?_c('v-btn',{attrs:{"color":"success","small":"","outline":"","href":_vm.fileUrl,"target":"_blank"}},[_vm._v("\n       "+_vm._s(_vm.$t('download'))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }